// generic-client
import type { TFunction } from 'i18next';

export enum ErrorCodes {
  MatchingPeerModal = 350001,
  CompleteProfile = 350002,
  PeerMatchHeader = 350003,
  WithdrawStatus = 350004,
  WithdrawCatch = 350005,
  BuyOrSell = 350006,
  DirectSellCrypto = 350007,
  PeerTransferFilter = 350008,
  ChangePasswordModal = 350009,
  UpdateProfile = 350010,
  ErrorMessageApollo = 350011,
  SignUpConfirmation = 350012,
  SecondaryEmail = 350013,
  Client = 350014,
}

type Error = {
  type: string;
  title: string;
  message: string;
  autoClose?: boolean;
};

export const getErrorMessage = (t: TFunction, errorCode: ErrorCodes): string =>
  `${t('ERRORS:UNEXPECTED_ERROR')} - ${errorCode}`;
export const getError = (t: TFunction, errorCode: ErrorCodes, override?: Error): Error => ({
  type: 'error',
  title: t('ERRORS:ERROR'),
  message: getErrorMessage(t, errorCode),
  ...(override || {}),
});
export const hasMessageError = (messageError: string) => (messageError || '').includes(' - 350');

export default {
  hasMessageError,
};
